var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Snackbar'),(!_vm.hasBackEndApiKey)?_c('SystemBar'):_vm._e(),_c('v-main',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"10","offset-lg":"1","xl":"8","offset-xl":"2"}},[_c('Header'),_c('router-view')],1)],1)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }